import * as React from 'react'

function IconPopArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={85}
      viewBox="0 0 20 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#prefix__filter0_d)">
        <path
          d="M6.892 37.123l3.629-2.64c1.17-.853 1.89-2.43 1.89-4.137v-15.1C12.411 9.588 16.045 5 20.527 5H149.39c4.476 0 8.11 4.582 8.11 10.246v54.508c0 5.658-3.634 10.246-8.115 10.246H20.527c-4.482 0-8.116-4.588-8.116-10.246V52.18c0-1.706-.72-3.283-1.89-4.136l-3.63-2.647c-2.522-1.837-2.522-6.437 0-8.274z"
          fill="#F2F2F2"
        />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d"
          x={0}
          y={0}
          width={20}
          height={85}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={2.5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default IconPopArrow
